import React, {Component} from 'react'
import {connect} from 'react-redux'
import { Button } from 'semantic-ui-react'
import {toggleModal} from "../../Actions/ToggleModal";
import {modifyEditID} from "../../Actions/ModifyEditID";

class BlockRequestsButton extends Component {
    openModal = e => {
        this.props.modifyEditID(this.props.pkID);
        this.props.toggleModal("blockRequestsModal")
    }

    render() {
        return (
            <div>
                <Button content="Block Request Type" basic color='red' icon='lock' onClick={this.openModal} fluid/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({})

const mapActionsToProps = {
    toggleModal: toggleModal,
    modifyEditID: modifyEditID
}

export default connect(mapStateToProps, mapActionsToProps)(BlockRequestsButton)